module.exports = __webpack_public_path__ + "static/img/trophy.cc5215cc.png";